/*
 * TODO: Filters de-coffee & refactor: Consider move these action to useFilters hook and use it in:
 *
 *  * apps/publisher/javascripts/components/scheduled_events/filter_list/error_alert.coffee
 *  * apps/publisher/javascripts/components/scheduled_events/filter_list/index.coffee
 *  * apps/publisher/javascripts/components/scheduled_events/links/filter_by_event_type.coffee
 */

export const changeFilterBarVisibility = (showFiltersBar) => ({
  type: 'CHANGE_FILTERS_BAR_VISIBILITY',
  payload: { showFiltersBar }
})

export const setFiltersError = (type) => ({
  type: 'SET_FILTERS_ERROR',
  payload: {
    type
  }
})

export const clearFiltersError = () => ({
  type: 'CLEAR_FILTERS_ERROR'
})
